// SHRINE CART FIX TEST
;(() => {
  const nativeFetch = window.fetch.bind(window);

  const HARNESS_PRODUCT_IDS = new Set([
    10480234496346, // Control harness
    10647096459610  // Variant A bundle harness
  ]);

  const LOWEN_CART_PRODUCT_IDS = new Set([
    // Control products
    10804952039770, // Control Custom Name Tag
    10480234496346, // Control harness
    10362135052634, // Control No-Pull Dog Leash
    10728156070234, // Control Mystery Digital Box
    10480268050778, // Control 1-Year Guarantee

    // Variant A bundle products
    10851129917786, // Variant A Custom Name Tag
    10647096459610, // Variant A bundle harness
    10349331022170, // Variant A No-Pull Dog Leash
    10851139780954, // Variant A Mystery Digital Box
    10855018725722, // Variant A 1-Year Guarantee

    // Shared product
    10259522617690 // Shipping Protection
  ]);

  const isCartChangeRequest = (input) => {
    const url =
      typeof input === 'string'
        ? input
        : input?.url || '';

    return /\/cart\/change(?:\.js)?(?:\?|$)/.test(url);
  };

  const readJsonBody = (body) => {
    if (typeof body !== 'string') return null;

    try {
      return JSON.parse(body);
    } catch {
      return null;
    }
  };

  const buildClearUrl = (input) => {
    const url =
      typeof input === 'string'
        ? input
        : input?.url || '/cart/change.js';

    return url.replace(
      /\/cart\/change(?:\.js)?/,
      '/cart/clear.js'
    );
  };

  window.fetch = async function lowenCartGiftFix(
    input,
    init = {}
  ) {
    if (!isCartChangeRequest(input)) {
      return nativeFetch(input, init);
    }

    const payload = readJsonBody(init.body);

    if (
      !payload ||
      Number(payload.quantity) !== 0 ||
      payload.line === undefined ||
      payload.line === null
    ) {
      return nativeFetch(input, init);
    }

    try {
      const cartResponse = await nativeFetch('/cart.js', {
        credentials: 'same-origin'
      });

      const cart = await cartResponse.json();
      const lineIndex = Number(payload.line) - 1;
      const targetItem = cart.items?.[lineIndex];

      if (
        !targetItem ||
        !HARNESS_PRODUCT_IDS.has(
          Number(targetItem.product_id)
        )
      ) {
        return nativeFetch(input, init);
      }
      const harnessLines = cart.items.filter(
        (item) =>
          HARNESS_PRODUCT_IDS.has(
            Number(item.product_id)
          )
      );

      if (harnessLines.length > 1) {
        console.info(
          '[LOWEN] Multiple harness lines detected. Removing only the selected harness line.'
        );

        return nativeFetch(input, init);
      }

      const containsOnlyLowenItems = cart.items.every(
        (item) =>
          LOWEN_CART_PRODUCT_IDS.has(
            Number(item.product_id)
          )
      );

      if (!containsOnlyLowenItems) {
        console.warn(
          '[LOWEN] Harness removal detected, but unrelated cart items are present. Falling back to Shrine.'
        );

        return nativeFetch(input, init);
      }

      console.info(
        '[LOWEN] Harness removal intercepted. Clearing dependent LOWEN cart items in one request.'
      );

      const clearPayload = {
        sections:
          payload.sections || [
            'cart-drawer',
            'cart-icon-bubble'
          ],
        sections_url:
          payload.sections_url || window.location.pathname
      };

      return nativeFetch(buildClearUrl(input), {
        ...init,
        method: 'POST',
        headers: {
          ...(init.headers || {}),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(clearPayload)
      });
    } catch (error) {
      console.error(
        '[LOWEN] Local cart fix failed. Falling back to Shrine.',
        error
      );

      return nativeFetch(input, init);
    }
  };

  console.info('[LOWEN] cart-gift-fix.js loaded');
})();